import { DirectionIdData, Segment } from "src/models/route";
import { Terminal } from "src/models/terminal";
import { ColorSchemeSetting } from "./colorScheme";

export type LocalStorageKey =
  | "DEVICE-ID-FOR-APPCUES"
  | "LADDER-ZOOM"
  | "MOST-RECENT-LADDER-SEGMENT"
  | "MOST-RECENT-TRAINSHEET-TERMINAL"
  | "MOST-RECENT-PREDICTIONS-DIRECTION"
  | "COLOR-SCHEME"
  | "SCENARIO"
  | "BETA-FEATURES";

type LocalStorageTypes = {
  "DEVICE-ID-FOR-APPCUES": string;
  "LADDER-ZOOM": string;
  "MOST-RECENT-LADDER-SEGMENT": Segment;
  "MOST-RECENT-TRAINSHEET-TERMINAL": Terminal;
  "MOST-RECENT-PREDICTIONS-DIRECTION": DirectionIdData;
  "COLOR-SCHEME": ColorSchemeSetting;
  SCENARIO: string;
  "BETA-FEATURES": string;
};

export const getLocalStorage = <Key extends LocalStorageKey>(
  key: Key,
): LocalStorageTypes[Key] | null =>
  localStorage.getItem(key) as LocalStorageTypes[Key];

export const setLocalStorage = <Key extends LocalStorageKey>(
  key: Key,
  value: LocalStorageTypes[Key],
) => localStorage.setItem(key, value);
